import { render, staticRenderFns } from "./LogbookTable.vue?vue&type=template&id=0ed01461&scoped=true&"
import script from "./LogbookTable.vue?vue&type=script&lang=js&"
export * from "./LogbookTable.vue?vue&type=script&lang=js&"
import style0 from "./LogbookTable.vue?vue&type=style&index=0&id=0ed01461&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ed01461",
  null
  
)

export default component.exports